import { render } from "./IntentionSetterV1Switch.vue?vue&type=template&id=ce90313c&scoped=true"
import script from "./IntentionSetterV1Switch.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1Switch.vue?vue&type=script&lang=js"

import "./IntentionSetterV1Switch.vue?vue&type=style&index=0&id=ce90313c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce90313c"]])

export default __exports__